import { Typography } from "@material-ui/core";
import React from "react";
export const Paragraph = props => {
    return React.createElement(Typography, Object.assign({ variant: "body1" }, props));
};
